// Design tokens for the redesigned landing page.
// Mono-indigo, gradient-free: the brand color (#667eea) carries the whole page,
// paired with a near-black "night" canvas and clean white surfaces.

export const landingColors = {
  indigo: '#667eea',
  indigoStrong: '#4f5bd5',
  indigoDeep: '#3a3f9e',
  indigoSoft: '#eef0fd',

  night: '#0b0b14',
  nightPanel: '#13131f',
  nightLine: 'rgba(255, 255, 255, 0.12)',
  onNight: '#ffffff',
  onNightMuted: 'rgba(255, 255, 255, 0.66)',

  paper: '#ffffff',
  paperAlt: '#f5f5f9',
  ink: '#14141f',
  inkMuted: '#5d5d6e',
  line: 'rgba(20, 20, 31, 0.08)',
};

export const landingFont =
  '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", sans-serif';

// Shared eyebrow label style (uppercase, tracked-out) used above section headings.
export const eyebrowSx = {
  display: 'inline-block',
  fontSize: { xs: '0.7rem', md: '0.75rem' },
  fontWeight: 700,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
};

export const sectionHeadingSx = {
  fontWeight: 800,
  letterSpacing: '-0.02em',
  lineHeight: 1.08,
  fontSize: { xs: '2rem', sm: '2.6rem', md: '3.4rem' },
};
